/* ==========================================================================
   SelectRxjs > Template
   ========================================================================== */

/* Import modules */
const { html } = require('common-tags');

const { prepareDataConfig } = require('@bluekiri/alexandria/helpers/dataHelpers');

const { sanitizeObject, sanitizeSingleQuote } = require('../../helpers/sanitize');

const configuration = require('./client/js/config');

/**
 * SelectRxjs template
 * @param {object} data Object containing the data model for this component.
 * @returns {string} Html
 */
module.exports = function Template(data = {}) {
    /* Data */
    const { config = {}, label, items, value, multiple = false, disabled = false, hasLoader = true } = data;
    const { styles = [], literals = {} } = config;
    const { dataType } = prepareDataConfig(config.data);

    /* Template */
    return html(`
        <div class='${[
            'select-rxjs',
            label ? configuration().css.withLabel : '',
            multiple ? configuration().css.multiple : '',
            ...styles
        ]
            .join(' ')
            .trim('')}'
            data-component='${configuration().component}'
            ${dataType ? `data-type='${dataType}'` : ''}
            data-config='${sanitizeSingleQuote(
                JSON.stringify({
                    ...config,
                    value,
                    items,
                    literals: sanitizeObject(literals),
                    multiple,
                    disabled,
                    hasLoader
                })
            )}'>

            ${label ? `<label>${label}</label>` : ''}
            <select ${multiple ? 'multiple' : ''}></select>
        </div>
    `);
};
